import { render, staticRenderFns } from "./GeneralAnnouncement.vue?vue&type=template&id=6776bcfc"
import script from "./GeneralAnnouncement.vue?vue&type=script&lang=js"
export * from "./GeneralAnnouncement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports